import React, { ReactNode } from 'react';

import { Box, Typography, useTheme } from '@material-ui/core';
import clsx from 'clsx';
import { MdIndeterminateCheckBox } from 'react-icons/md';

import { AppCheckbox } from '../../../components/inputs';
import { useReportStyles } from '../styles';

interface Props {
  label: ReactNode;
  /** Secondary text after the label, e.g. a member count */
  meta?: ReactNode;
  checked: boolean;
  /** Part of the list is selected: only for a "select all" row */
  indeterminate?: boolean;
  onToggle: () => void;
  /** The "select all" row heading a list: bolder, with a rule under it */
  selectAll?: boolean;
  ariaLabel: string;
}

/** A checkbox row that highlights across its full width when selected; click anywhere on it. */
export const SelectRow: React.FC<Props> = ({
  label,
  meta,
  checked,
  indeterminate = false,
  onToggle,
  selectAll = false,
  ariaLabel,
}) => {
  const classes = useReportStyles();
  const theme = useTheme();

  return (
    <Box
      className={clsx(classes.selectRow, {
        [classes.selectRowSelected]: checked || indeterminate,
        [classes.selectAllRow]: selectAll,
      })}
      onClick={onToggle}>
      <Typography variant="body2" className={clsx({ [classes.selectAllLabel]: selectAll })}>
        {label}
        {meta !== undefined && (
          <Typography component="span" className={classes.hint}>
            {' '}
            · {meta}
          </Typography>
        )}
      </Typography>
      <AppCheckbox
        checked={checked}
        indeterminate={indeterminate}
        indeterminateIcon={<MdIndeterminateCheckBox size={16} color={theme.palette.primary.main} />}
        color="primary"
        variant="rectangle"
        onClick={event => event.stopPropagation()}
        onChange={onToggle}
        inputProps={{ 'aria-label': ariaLabel }}
      />
    </Box>
  );
};
